import { Component, OnInit, inject, signal } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Router, ActivatedRoute, RouterLink } from "@angular/router";
import { MessageService, ConfirmationService, SelectItem } from "primeng/api";
import { Observable, of } from "rxjs";
import { AbstractFormComponent } from "src/app/common/abstract-edit.component";
import {
  COUNTRY_LIST,
  FISCAL_CODE_VALIDATOR_REGEX,
  PARAM_CLIENTS_PATH,
  STATE_LIST,
} from "src/app/constants/constants";
import { BookingsService } from "src/app/services/bookings.service";
import { Employees } from "src/app/models/employees";
import { Category } from "src/app/models/category";
import { Locations } from "src/app/models/locations";
import { NgxSpinnerService } from "ngx-spinner";
import { Bookings } from "src/app/models/bookings";
import { EmployeesService } from "src/app/services/employees.service";
import { Bind } from "primeng/bind";
import { ButtonDirective } from "primeng/button";
import { Card } from "primeng/card";
import { Tabs, TabList, Tab, TabPanels, TabPanel } from "primeng/tabs";
import { Ripple } from "primeng/ripple";
import { SelectButton } from "primeng/selectbutton";
import { InputText } from "primeng/inputtext";
import { InputMask } from "primeng/inputmask";
import { Select } from "primeng/select";
import { Textarea } from "primeng/textarea";

import { ConfirmDialog } from "primeng/confirmdialog";
import { Toast } from "primeng/toast";
import { TranslatePipe } from "@ngx-translate/core";

import { TPipe } from "../../i18n/t.pipe";
import { PhoneInputComponent } from "../../components/phone-input/phone-input.component";
@Component({
    standalone: true,
    selector: "app-employees-form",
    templateUrl: "./employees-form.component.html",
    imports: [PhoneInputComponent, TPipe, FormsModule, ReactiveFormsModule, Bind, ButtonDirective, RouterLink, Card, Tabs, TabList, Ripple, Tab, TabPanels, TabPanel, SelectButton, InputText, InputMask, Select, Textarea, ConfirmDialog, Toast, TranslatePipe]
})
export class EmployeesFormComponent
  extends AbstractFormComponent<Employees>
  implements OnInit
{
  protected fb: FormBuilder;
  private bookingsService = inject(BookingsService);
  private employeesService = inject(EmployeesService);
  private spinner = inject(NgxSpinnerService);

  pageTitle: string;
  form: FormGroup;
  idField = "id";
  formFields = [
    "id",
    "name",
    "surname",
    "city",
    "zip",
    "address",
    "province",
    "region",
    "email",
    "phone",
    "fiscalcode",
    "fiscalnumber",
    "description",
    "is_active",
    "is_featured",
    "image",
    "contract",
    "vacations",
    "permissions",
  ];

  item$: Observable<Employees> = of();
  stateOptions = STATE_LIST;
  service = this.employeesService;
  bookings: Bookings[];
  categories: Category[] = [];
  category: Category;
  locations: Locations[] = [];
  location: Locations;
  readonly countries = signal<any[]>(undefined);
  readonly booking = signal<Bookings>(undefined);
  readonly bookedDialog = signal<boolean>(false);

  constructor() {
    const fb = inject(FormBuilder);
    const messageService = inject(MessageService);
    const confirmationService = inject(ConfirmationService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(
      fb,
      messageService,
      confirmationService,
      router,
      route,
      PARAM_CLIENTS_PATH,
    );

    this.fb = fb;
  }

  ngOnInit() {
    this.initializeForm();
    this.countries.set(COUNTRY_LIST);

    const id = this.route.snapshot.paramMap.get("id");
    if (id) {
      this.pageTitle = "Modifica Impiegato";
      this.loadItem(id);
    } else {
      this.pageTitle = "Aggiungi Impiegato";
    }
  }

  editRoom(booking: Bookings) {
    this.booking.set({ ...booking });
    this.bookedDialog.set(true);
  }

  initializeForm() {
    this.form = this.fb.group({
      id: [""],
      name: ["", Validators.required],
      surname: ["", Validators.required],
      username: [""],
      city: [""],
      zip: [""],
      address: [""],
      province: [""],
      region: [""],
      email: [""],
      phone: [""],
      fiscalcode: new FormControl("", Validators.compose([codFisc])),
      fiscalnumber: new FormControl(""),
      description: [""],
      is_featured: [""],
      is_active: ["0"],
      image: [""],
      contract: [""],
      vacations: [""],
      permissions: [""],
    });
  }

  loadItem(id: string) {
    this.service.getId(id).subscribe(
      (res) => {
        this.form.patchValue({
          name: res.name,
          surname: res.surname,
          username: res.name + " " + res.surname,
          city: res.city,
          zip: res.zip,
          address: res.address,
          province: res.province,
          region: res.region,
          email: res.email,
          phone: res.phone,
          contract: res.contract,
          vacations: res.vacations,
          permissions: res.permissions,
          fiscalcode: res.fiscalcode,
          fiscalnumber: res.fiscalnumber,
          description: res.description,
          is_featured: res.is_featured,
          is_active: res.is_active,
          id: res.id,
        });
      },
      (error) => (this.error = error),
    );
  }
}

export function codFisc(c: FormControl): { [s: string]: boolean } {
  if (c.value && !c.value.match(FISCAL_CODE_VALIDATOR_REGEX)) {
    return { invalidCF: true };
  }
}
